export const getPlaylistItemStatus = cardModel => {
  var _cardModel$progress;
  let status = (cardModel === null || cardModel === void 0 || (_cardModel$progress = cardModel.progress) === null || _cardModel$progress === void 0 ? void 0 : _cardModel$progress.status) || 'NOT_STARTED';
  if (status === 'EXPIRING_SOON') {
    status = 'COMPLETED';
  }
  return status;
};